import { CdkMenuModule } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { GenericModule } from 'src/app/generic/generic.module';
import { MentionPipe } from 'src/app/pipes/mention.pipe';
import { RelativeTimePipe } from 'src/app/pipes/relative-time.pipe';
import { ShortNumberPipe } from 'src/app/pipes/short-number.pipe';
import { TableTitlePipe } from 'src/app/pipes/table-title.pipe';
import { AiMessageComponent } from './ai-message/ai-message.component';
import { AiReportsChatsComponent } from './ai-reports-chats/ai-reports-chats.component';
import { UserMentionComponent } from './user-mention/user-mention.component';

@NgModule({
    declarations: [AiReportsChatsComponent, AiMessageComponent],
    imports: [
        CommonModule,
        FormsModule,
        GenericModule,
        VirtualScrollerModule,
        CdkMenuModule,
        RelativeTimePipe,
        ShortNumberPipe,
        TableTitlePipe,
        MentionPipe,
        UserMentionComponent,
    ],
    providers: [MentionPipe],
})
export class AiReportsModule {}
